import { mediaFileUrl } from '../../api/media.ts';
import { overlayPreviewModel, type OverlayFormValues } from '../../lib/overlay-preview.ts';

/**
 * Live 16:9 preview of an overlay over a dark "screen" (docs/09 §C2 — the demo
 * surface). Shows the logo at its corner/size/opacity and the ticker scrolling.
 * `accent` (a brand color) tints the ticker so the preview feels on-brand.
 */
export function OverlayPreview({
  values,
  accent,
}: {
  values: OverlayFormValues;
  accent?: string | null;
}) {
  const model = overlayPreviewModel(values);
  const style = accent ? ({ '--ov-accent': accent } as React.CSSProperties) : undefined;

  return (
    <div className="ov-preview" style={style} aria-label="Overlay preview">
      <div className="ov-preview-scene">
        <span className="ov-preview-tag">Preview</span>

        {model.hasLogo && values.logo_media_id && (
          <img
            className={`ov-preview-logo ${model.cornerClass}`}
            src={mediaFileUrl(values.logo_media_id)}
            alt=""
            style={{ width: `${model.sizePct}%`, opacity: model.opacity }}
          />
        )}

        {model.hasTicker && (
          <div className="ov-preview-ticker">
            <div className="ov-preview-ticker-track">
              <span className="ov-preview-ticker-text">{model.tickerText}</span>
              <span className="ov-preview-ticker-text" aria-hidden="true">
                {model.tickerText}
              </span>
            </div>
          </div>
        )}

        {!model.hasContent && (
          <div className="ov-preview-empty">Add a logo or ticker to see it here</div>
        )}
      </div>
    </div>
  );
}
